<template>
  <page :name="name">
    <x-nav slot="header">{{ title }}</x-nav>
    
    <a @click="$root.goto('InducteeDetailsPage', $root.nowPlaying(playlist).InducteeID)">
      <x-now-playing
      text="NOW PLAYING"
      :inductee="$root.nowPlaying(playlist)"
      ></x-now-playing>
    </a>
    
    <div>
      <playlist-item
      v-for="(inductee, index) of $root[playlist].slice(1)"
      :inductee="inductee"
      @buttonClick="$root.bump({playlist, inductee})"
      ></playlist-item>
    </div>
  
    <x-footer slot="footer">
      <a class="button" @click="$root.goto('InducteePage')">
        <img src="img/addcircle_icon.png" class="button-icon">Explore and Listen</span>
      </a>
    </x-footer>
  </page>
</template>

<script>
export default {
  components: {
    'page': require('./Page.vue'),
    'x-nav': require('./Nav.vue'),
    'x-footer': require('./Footer.vue'),
    'x-now-playing': require('./NowPlaying.vue'),
    'playlist-item': require('./PlaylistItem.vue'),
  },
  props: [
    'playlist',
  ],
  computed: {
    title () {
      return this.playlist[0].toUpperCase() + this.playlist.slice(1)
    },
    name () {
      return this.title + 'Page'
    }
  }
}
</script>
